export default __webpack_public_path__ + "static/media/icon-negotiation-active.9066a43e.svg";